export const getFormattedSdkErrorMessage = (err: any, message: string) => {
    if (!err) {
        return message;
    }

    let result = message;
    if (err.$metadata?.httpStatusCode != null) {
        result = `${result} ${err.$metadata.httpStatusCode}`;
    }
    if (err.name) {
        result = `${result} | ${err.name}`;
    }
    if (err.message) {
        result = `${result}: ${err.message}`;
    }
    if (err.$metadata?.requestId) {
        result = `${result} (requestID: ${err.$metadata.requestId})`;
    }
    return result;
};
